var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGf(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 513,
    height: 343,
    viewBox: "0 0 513 343",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_301_1164)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0.892578L513 342.893H0V0.892578Z",
    fill: "#FDEB01"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M513 0.892578V342.893L0 0.892578H513Z",
    fill: "#58A846"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.99 190.703L342 152.513H276.45L256.5 90.3828L236.55 152.513H171L224.01 190.703L203.49 253.403L256.5 215.213L309.51 253.403L288.99 190.703Z",
    fill: "#ED3D24"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_301_1164"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 513,
    height: 342,
    fill: "white",
    transform: "translate(0 0.892578)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGf);
export default __webpack_public_path__ + "static/media/GF.e7cb691f138ba628882578df417075ee.svg";
export { ForwardRef as ReactComponent };